(function () {
	'use strict';

	angular.module('widgets.initiative')
		.service('unableToFixValueParetoService', unableToFixValueParetoService);

	function unableToFixValueParetoService($http, $q, URLS) {
		var fiscalPastTimePeriods = {
			previous: true,
			currentFiscalYTD: true
		};

		return {
			getUnableToFixValueParetoData: getUnableToFixValueParetoData,
			resolveCreatedDateDrilldownRange: resolveCreatedDateDrilldownRange,
			buildCreatedDateDrilldownParams: buildCreatedDateDrilldownParams
		};

		function isFiscalPastTimePeriod(pastTimePeriod) {
			return !!fiscalPastTimePeriods[pastTimePeriod];
		}

		function isDayBasedPastTimePeriod(pastTimePeriod) {
			return pastTimePeriod != null && !isNaN(pastTimePeriod);
		}

		function hasValidDrilldownRange(createdDateDrilldownRange) {
			return createdDateDrilldownRange
				&& createdDateDrilldownRange.start != null
				&& createdDateDrilldownRange.end != null;
		}

		function computeDayBasedDrilldownRange(pastTimePeriod) {
			var daysBack = parseInt(pastTimePeriod, 10);
			var endDateStr = moment.utc(new Date()).format('YYYY-MM-DD');
			var startDateStr = moment.utc(new Date()).subtract(daysBack, 'd').format('YYYY-MM-DD');
			return {
				start: moment.utc(startDateStr).unix() * 1000,
				end: moment.utc(endDateStr).unix() * 1000
			};
		}

		function buildCreatedDateDrilldownParams(pastTimePeriod, createdDateDrilldownRange) {
			if (!pastTimePeriod || pastTimePeriod === 'all') {
				return null;
			}

			if (!hasValidDrilldownRange(createdDateDrilldownRange)) {
				return null;
			}

			return {
				creationDateValueOne: createdDateDrilldownRange.start,
				creationDateValueTwo: createdDateDrilldownRange.end,
				creationDateComparator: 'btw'
			};
		}

		function fetchCreatedDateDrilldownRange(filterService, pastTimePeriod) {
			var url = String.format(URLS.host + URLS.inventoryActionUnableToFixValuePareto,
				filterService.getFactoryList());
			var filterQueryParams = {
				dateToGroupBy: 'dateCreated',
				pastTimePeriod: pastTimePeriod,
				drilldownRangeOnly: true
			};

			url = addQueryParam(url, filterService.getFactoryList(), filterQueryParams, false);

			return $http.get(url)
				.then(function (response) {
					if (response && response.data && hasValidDrilldownRange(response.data.createdDateDrilldownRange)) {
						return response.data.createdDateDrilldownRange;
					}
					return null;
				})
				.catch(function () {
					return null;
				});
		}

		function resolveCreatedDateDrilldownRange(filterService, pastTimePeriod, paretoResponse) {
			if (!pastTimePeriod || pastTimePeriod === 'all') {
				return $q.when(null);
			}

			if (paretoResponse && hasValidDrilldownRange(paretoResponse.createdDateDrilldownRange)) {
				return $q.when(paretoResponse.createdDateDrilldownRange);
			}

			if (isDayBasedPastTimePeriod(pastTimePeriod)) {
				return $q.when(computeDayBasedDrilldownRange(pastTimePeriod));
			}

			if (isFiscalPastTimePeriod(pastTimePeriod)) {
				return fetchCreatedDateDrilldownRange(filterService, pastTimePeriod);
			}

			return $q.when(null);
		}

		function getUnableToFixValueParetoData(filterService, ignoreFilters, pastTimePeriod) {
			var url = String.format(URLS.host + URLS.inventoryActionUnableToFixValuePareto,
				filterService.getFactoryList());

			var filterQueryParams = filterService.getQueryParamsObject(true);
			filterQueryParams.dateToGroupBy = 'dateCreated';
			if (pastTimePeriod != null) {
				filterQueryParams.pastTimePeriod = pastTimePeriod;
			}

			if (ignoreFilters) {
				filterQueryParams = _.omit(filterQueryParams, ignoreFilters);
			}

			url = addQueryParam(url,
				filterService.getFactoryList(), filterQueryParams, false);

			return $http.get(url)
				.then(function (response) {
					if (response && response.data && !Array.isArray(response.data)) {
						return response.data;
					}
					return { data: [] };
				})
				.catch(function (error) {
					return error;
				});
		}
	}
})();
